import React from 'react'

const PaymentDisclaimer = () => (
  <p
    className="text-secondary small"
    style={{ marginTop: '5px' }}
  >
    <i className="fal fa-shield-check"/>
    &nbsp;We use&nbsp;
    <a
      tabIndex={-1}
      href="https://stripe.com"
      target="_blank"
      rel="noopener noreferrer"
      className="text-info"
    >
      Stripe
    </a>
    &nbsp;to encrypt and process payments securely.
  </p>
)

export default PaymentDisclaimer



// WEBPACK FOOTER //
// ./src/components/ui/typography/PaymentDisclaimer.js